import { Box, CardMedia, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import trustTextBg from '../../../images/Group 1.png';
import trustFirst from '../../../images/trustUs1.png';
import trustSecond from '../../../images/trustUs2.png';
import trustThird from '../../../images/trustUs3.png';
import trustFourth from '../../../images/trustUs4.png';
import trustBg from '../../../images/connect-bg.png';
import trustFirstBg from '../../../images/Vector 71.png';
import trustFourthBg from '../../../images/Vector 67.png';
import cardLeftBg from '../../../images/Rectangle 283.png';
import cardRightBg from '../../../images/Rectangle 284.png';
import './TrustUs.css';

const servicesTextBg = {
    backgroundImage: `url(${trustTextBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}
const setTrustBg = {
    backgroundImage: `url(${trustBg})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat'
}
const setTrustFirstBg = {
    backgroundImage: `url(${trustFirstBg})`,
    backgroundPosition: 'left 3% top 8%',
    backgroundRepeat: 'no-repeat'
}
const setTrustFourthBg = {
    backgroundImage: `url(${trustFourthBg})`,
    backgroundPosition: 'right 1% bottom 6%',
    backgroundRepeat: 'no-repeat'
}
const trustLeftBg = {
    backgroundImage: `url(${cardLeftBg})`,
    backgroundPosition: 'left bottom 15%',
    backgroundRepeat: 'no-repeat'
}
const trustRightBg = {
    backgroundImage: `url(${cardRightBg})`,
    backgroundPosition: 'right top 10%',
    backgroundRepeat: 'no-repeat'
}

const TrustUs = () => {
    return (
        <div style={setTrustBg}>
            <Container sx={{ mt: 6 }}>
                <Box style={servicesTextBg} sx={{ textAlign: 'left' }}>
                    <Typography variant="h6" id="trust-head" sx={{ color: '#0015D1', textDecoration: 'underline', fontWeight: 600, fontSize: '35px', pt: '2%' }}>
                        Why Trust Us
                    </Typography>
                    <Typography variant="h3" id="trust-message" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600 }}>
                        We Are Here To Change Your Business Look !
                    </Typography>
                </Box>
            </Container>
            <Box id="large-box" style={setTrustFirstBg}>
                <Box style={setTrustFourthBg}>
                    <Container>
                        <Grid container>
                            <Grid item sm={6} md={6}>
                                <CardMedia
                                    className='trust-hover-effect'
                                    component="img"
                                    sx={{ my: 3, width: '75%', mx: 'auto' }}
                                    alt="trust us"
                                    image={trustFirst}
                                />
                                <CardMedia
                                    className='trust-hover-effect'
                                    component="img"
                                    sx={{ my: 12, width: '75%', mx: 'auto' }}
                                    alt="trust us"
                                    image={trustSecond}
                                />
                            </Grid>
                            <Grid item sm={6} md={6}>
                                <CardMedia
                                    className='trust-hover-effect'
                                    component="img"
                                    sx={{ mt: 24, width: '75%', mx: 'auto' }}
                                    alt="trust us"
                                    image={trustThird}
                                />
                                <CardMedia
                                    className='trust-hover-effect'
                                    component="img"
                                    sx={{ my: 12, width: '75%', mx: 'auto' }}
                                    alt="trust us"
                                    image={trustFourth}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </Box>
            <Box id="small-box" style={trustLeftBg}>
                <Box style={trustRightBg}>
                    <Box style={setTrustFourthBg}>
                        <Box sx={{ width: '87%', mx: 'auto' }}>
                            <Grid container sx={{ my: 2 }} spacing={2}>
                                <Grid item xs={6}>
                                    <CardMedia
                                        component="img"
                                        sx={{ boxShadow: '0px 0px 7px 0px rgba(207, 207, 207, 0.83)' }}
                                        alt="trust us"
                                        image={trustFirst}
                                    />
                                </Grid>
                                <Grid item sx={{ display: 'flex', textAlign: 'left', alignItems: 'center' }} xs={6}>
                                    <Box>
                                        <Typography sx={{ color: "#ffffff", backgroundColor: '#000D83', fontWeight: 600, fontSize: '12px', borderRadius: 0, height: '19px', width: '30px' }}>
                                            <span style={{ paddingLeft: '7px' }}>We</span>
                                        </Typography>
                                        <Typography sx={{ color: '#000D83', fontWeight: 700, fontSize: '12px' }}>
                                            get your <br /> concept learned
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ my: 2 }} spacing={2}>
                                <Grid item sx={{ display: 'flex', textAlign: 'left', alignItems: 'center' }} xs={6}>
                                    <Box sx={{ ml: 5 }}>
                                        <Typography sx={{ color: "#ffffff", backgroundColor: '#000D83', fontWeight: 600, fontSize: '12px', borderRadius: 0, height: '19px', width: '30px' }}>
                                            <span style={{ paddingLeft: '7px' }}>We</span>
                                        </Typography>
                                        <Typography sx={{ color: '#000D83', fontWeight: 700, fontSize: '12px' }}>
                                            Brainstorm
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6}>
                                    <CardMedia
                                        component="img"
                                        sx={{ boxShadow: '0px 0px 7px 0px rgba(207, 207, 207, 0.83)' }}
                                        alt="trust us"
                                        image={trustThird}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container sx={{ my: 2 }} spacing={2}>
                                <Grid item xs={6}>
                                    <CardMedia
                                        component="img"
                                        sx={{ boxShadow: '0px 0px 7px 0px rgba(207, 207, 207, 0.83)' }}
                                        alt="trust us"
                                        image={trustSecond}
                                    />
                                </Grid>
                                <Grid item sx={{ display: 'flex', textAlign: 'left', alignItems: 'center' }} xs={6}>
                                    <Box>
                                        <Typography sx={{ color: "#ffffff", backgroundColor: '#000D83', fontWeight: 600, fontSize: '12px', borderRadius: 0, height: '19px', width: '30px' }}>
                                            <span style={{ paddingLeft: '7px' }}>We</span>
                                        </Typography>
                                        <Typography sx={{ color: '#000D83', fontWeight: 700, fontSize: '12px' }}>
                                            We pitch you <br /> our design
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ my: 2 }} spacing={2}>
                                <Grid item sx={{ display: 'flex', textAlign: 'left', alignItems: 'center' }} xs={6}>
                                    <Box sx={{ ml: 3 }}>
                                        <Typography sx={{ color: "#ffffff", backgroundColor: '#000D83', fontWeight: 600, fontSize: '12px', borderRadius: 0, height: '19px', width: '30px' }}>
                                            <span style={{ paddingLeft: '7px' }}>We</span>
                                        </Typography>
                                        <Typography sx={{ color: '#000D83', fontWeight: 700, fontSize: '12px' }}>
                                            we together make <br /> it successful
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6}>
                                    <CardMedia
                                        component="img"
                                        sx={{ boxShadow: '0px 0px 7px 0px rgba(207, 207, 207, 0.83)' }}
                                        alt="trust us"
                                        image={trustFourth}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default TrustUs;